//Custo css import
import './style.css'

//React import
import { useEffect, useState } from 'react';

//Widgets import
import { AiOutlineOrderedList } from 'react-icons/ai';
import ModalBtn from '../../molecules/modalButton/view';

import Table from '../../molecules/tablas/view';
import { getTaxes } from '../../../usecases/taxes-usecase';
import NewTax from '../newTax/view';
import { listener } from '../../../utils/dispatch';
import EditTax from '../editTax/view';
import PaginatedTable from '../../atoms/pagination/pagination';
import { EmptyArray } from '../../../domain/empty/model';

function TaxType(data) {
    const taxType = {
        "1": "IVA",
        "2": "IC",
        "3": "ICA",
        "4": "INC",
        "5": "ReteIVA",
        "6": "ReteRenta",
        "7": "ReteICA",
        "8": "FtoHorticultura",
        "9": "Timbre",
        "10": "INC Bolsas",
        "11": "INCarbono",
        "12": "INCombustibles",
        "13": "Sobretasa Combustibles",
        "14": "Sordicom",
        "16": "IC Porcentual",
        "17": "IC Datos",
        "18": "IVA e INC",
        "19": "No aplica",
        "20": "ICL",
        "21": "INPP",
        "22": "IBUA",
        "23": "ICUI"
    }
    const tipe = taxType[data.data.tax_type]
    return <p>{tipe}</p>
}

function Taxes() {

    const [taxes, SetTaxes] = useState({
        total: 0,
        page: 1,
        page_size: 10,
        data: [],
    })

    useEffect(() => {
        listener("update-taxes", () => update(1, 10))
    }, [])

    function update(page = taxes.page, limit = taxes.page_size) {
        SetTaxes(prev => ({ ...prev, data: [] }))
        getTaxes(page, limit).then(res => {
            if (res.data && Array.isArray(res.data.data)) {
                SetTaxes(res.data)
            } else {
                SetTaxes(res)
            }
        }).catch(() => {
            SetTaxes({
                data: EmptyArray,
                total: 0,
                page: page,
                page_size: limit
            })
        })
    }

    return (
        <ModalBtn
            id="taxesPlan"
            className='btn-acc-rep-modal'
            icon={<AiOutlineOrderedList></AiOutlineOrderedList>}
            title="Impuestos"
            onClick={update}
        >
            <Table
                paginatedData={taxes}
                getFunction={update}
                headersList={["Descripción", "Porcentaje", "Tipo"]}
                excludeList={[
                    "id",
                    "uid",
                    "cid",
                    "created_at",
                    "updated_at",
                    "tax_id",
                    "users_id",
                    "tax_accounts",
                    "accounts"
                ]}
                formats={{
                    value: { type: 'percentage' },
                    tax_type: { type: 'custom', children: <TaxType /> }
                }}
                toolbarActions={<NewTax />}
            >
                <EditTax></EditTax>
            </Table>
        </ModalBtn>
    )
}

export default Taxes
